import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { VideoClipperData } from '../../@types/video-clipper';

type Payload = {
  search?: string;
  status?: string;
  shouldFetchData?: boolean;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  filters?: { [key: string]: any };
};

const getAllAiClipperData = async (payload: Payload): Promise<VideoClipperData[]> => {
  const res = await axiosInstance.get('/api/video-clipper', {  params: {
      page: payload.page ?? 1,
      limit: payload.limit ?? 20,
      ...payload,
    }, });
  return res.data;
};

export const useGetAllAiClipperData = (payload: Payload) => {
  return useInfiniteQuery(
    ['getAllAiClipperData', payload],
    ({ pageParam = 1 }) => getAllAiClipperData({ ...payload, page: pageParam }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const currentPageDataLength = allPages[currentPage - 1].length;

        if (currentPageDataLength === payload?.limit) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};

export const useGetFiniteAiClipperData = (payload: Payload) => {
  return useQuery(['getAllAiClipperData', payload], () => getAllAiClipperData(payload), {
    enabled: payload?.shouldFetchData,
    keepPreviousData: true,
  });
};
